import React, { useEffect, useRef } from 'react'
import {
  IonContent,
  IonSkeletonText
} from '@ionic/react'
import AdvertisementSkeleton from '../../../components/skeletons/AdvertisementSkeleton'
import './styles.scss'

const ResultSkeleton = (props) => {
  const { bordered } = props
  return (
    <div className={bordered ? 'skeleton-result top-border' : 'skeleton-result' }>
      <figure>
        <IonSkeletonText className='image' animated />
      </figure>
      <figcaption>
        <IonSkeletonText className='title' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
        <div className='classification'>
          <div className='anchor'>
            <IonSkeletonText animated />
          </div>
          <div className='anchor'>
            <IonSkeletonText animated />
          </div>
        </div>
      </figcaption>
    </div>
  )
}

const LoadingLive = () => {

  return (
    <IonContent
      fullscreen
      className='loading-results page-wrapper'
    >
      <div className='flexible-width-content'>
        <AdvertisementSkeleton />
        <ResultSkeleton bordered />
        <ResultSkeleton />
        <ResultSkeleton />
        <ResultSkeleton />
        <ResultSkeleton />
        <ResultSkeleton />
        <ResultSkeleton />
        <ResultSkeleton />
        <AdvertisementSkeleton />
      </div>
    </IonContent>
  )
}

export default LoadingLive
